<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our Projects</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Our Projects</li>
                </ul>
            </div>
        </div> 
        <div class="container bottom-div wow fadeInUp" data-wow-delay="0.5s">
        </div>
    </div>
</section>


<div class="pt-5 pb-5 pos-list">
    <div class="container">
        <h2 class="text-center mb-5">List of Position</h2>
        <div class="row">
            <div class="col-md-4 offset-md-2">
                <ol start="1">
                    <li><strong>Hotel</strong>
                        <ul>
                            <li>Front Office</li>
                            <li>Reservation</li>
                            <li>Telephone Operator</li>
                            <li>Bellman</li>
                            <li>Waiter</li>
                            <li>Housekeeping</li>
                            <li>Linen</li>
                            <li>Sales Marketing</li>
                            <li>Manager</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-4">
                <ol start="2">
                    <li><strong>Restaurant</strong>
                        <ul>
                            <li>Sous Chef</li>
                            <li>Commis</li>
                            <li>Pastry Chef</li>
                            <li>Waiter</li>
                            <li>Barista</li>
                            <li>Waitres</li>
                            <li>Receptionist</li>
                            <li>Cashier</li>
                            <li>Hostes</li>
                            <li>Cook</li>
                            <li>Assistant Cook</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>

<div class="container pt-5">
    <div class="text-center wow fadeInUp pt-5">
        <h2 class="content-title">OUR PARTNERS</h2>
    </div>
    <div class="row pt-5">
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/Al-Mirqab-Facility-Management.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/Crowne-Plaza-logo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/curio-hilton.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/DoubletreeLogo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/Fraser-Suites_RGB.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/hilton-hotels-logo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/Laduree_logo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/laluce.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/prime.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/Pullman_Hotels_and_Resorts_Logo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/wyndham-doha-west-bay.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/wyndham-grand.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 offset-md-4 text-center">
            <img src="/assets/images/logo/industries/hotel-and-restaurant/trimmers.jpg" class="img-fluid" alt="">
        </div>
    </div>
</div>